export enum GroupCodes {
  GroupFlood = 'GroupFlood',
  GroupShortCircuit = 'GroupShortCircuit',
  GroupBurglary = 'GroupBurglary',
  FloodingEquipment = 'FloodingEquipment',
  FloodingFixedElements = 'FloodingFixedElements',
  VandalismEquipment = 'VandalismEquipment',
  VandalismFixedElements = 'VandalismFixedElements',
  FireFixedElements = 'FireFixedElements',
  FireEquipment = 'FireEquipment',
}
